export default __webpack_public_path__ + "static/media/bgHeader580.de89435b.webp";